import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
var validateSeurat = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validateSeurat() {
    return _ref.apply(this, arguments);
  };
}();
export default validateSeurat;